/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { TypographyProps } from '@mui/material/Typography';

import BasicModal from '@ui-parts/BasicModal';
import ModalBodyForInput from '@ui-parts/ModalBodyForInput';
import { ButtonProps } from '@mui/material/Button';

type InputProps = {
  // ↓rulesは動的なのでいったんlintエラーは無視してobjectで定義
  rules?: {};
  label?: string;
  nameProp: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  helperText?: string;
  width?: string;
  handleChange?: ButtonProps['onClick'];
  handleBlur?: ButtonProps['onClick'];
  onSubmit?: ButtonProps['onClick'];
  position?: 'center' | 'left' | 'right';
  textAlign?: 'center' | 'left' | 'right';
  errorWidth?: string;
  errorZIndex?: number;
  dataTestId?: string;
  onlyNum?: boolean;
  inputProps?: {};
  multiline?: boolean;
  rows?: number;
};

type Props = {
  open: boolean;
  handleClose: React.MouseEventHandler<HTMLButtonElement>;
  buttons: JSX.Element[];
  titleProps: {
    titleLabelVariant?: TypographyProps['variant'];
    titleVariant?: TypographyProps['variant'];
    descVariant?: TypographyProps['variant'];
    titleLabel?: string;
    title?: string;
    desc?: string;
  };
  inputs: InputProps[];
  // ↓rulesは動的なのでいったんlintエラーは無視してobjectで定義
  control: {};
  dataTestId: string;
  children?: React.ReactNode;
  width?: string;
};

const ModalWithInput: React.FC<Props & ButtonProps> = ({
  open,
  handleClose,
  buttons,
  titleProps,
  inputs,
  control,
  dataTestId,
  children,
  width,
}): JSX.Element => (
  <BasicModal
    open={open}
    titleProps={titleProps}
    buttons={buttons}
    handleClose={handleClose}
    disableAutoFocus
    dataTestId={dataTestId}
    width={width}
  >
    {children}
    <ModalBodyForInput inputs={inputs} control={control} />
  </BasicModal>
);

export default ModalWithInput;
